/**
 * api.js — All API calls to the heatmap backend (port 8001).
 * Proxy /api -> http://localhost:8001 is configured in vite.config.js.
 */

const BASE = "/api";

async function request(method, path, body = null) {
  const opts = { method, headers: {} };
  if (body instanceof FormData) {
    opts.body = body;
  } else if (body) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(BASE + path, opts);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json();
}

export const api = {
  /** Upload Excel file */
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return request("POST", "/upload", fd);
  },

  /** Start entire pipeline: scrape → enrich → score */
  startAll:   () => request("POST", "/tasks/start-all"),

  /** Start / pause / resume / stop a single step */
  startTask:  (step) => request("POST", `/tasks/${step}/start`),
  pauseTask:  (step) => request("POST", `/tasks/${step}/pause`),
  resumeTask: (step) => request("POST", `/tasks/${step}/resume`),
  stopTask:   (step) => request("POST", `/tasks/${step}/stop`),

  /** Progress, results, logs */
  getProgress:      ()              => request("GET", "/progress"),
  getResults:       (limit = 50, offset = 0) =>
                      request("GET", `/results?limit=${limit}&offset=${offset}`),
  getHeatmapPreview:(limit = 30)   => request("GET", `/heatmap-preview?limit=${limit}`),
  getLogs:          (limit = 200)  => request("GET", `/logs?limit=${limit}`),
  getColumnStats:   ()             => request("GET", "/column-stats"),

  /** Reset all data (wipes results, txt, Redis state) */
  reset: () => request("POST", "/reset"),

  /** Save a persistent snapshot of the current session */
  saveSession: () => request("POST", "/save-session"),

  /** Upload history */
  getHistory: () => request("GET", "/uploads/history"),

  /** Export status + pre-build trigger */
  getExportStatus:  ()  => request("GET",  "/export-status"),
  prepareExport:    ()  => request("POST", "/export-prepare"),

  /** Download URL */
  exportUrl: () => "/api/export",

  /** Health check */
  health: () => request("GET", "/health"),
};
